import { render, staticRenderFns } from "./MovementHistoryPage.vue?vue&type=template&id=242d8047&scoped=true&"
import script from "./MovementHistoryPage.vue?vue&type=script&lang=js&"
export * from "./MovementHistoryPage.vue?vue&type=script&lang=js&"
import style0 from "./MovementHistoryPage.vue?vue&type=style&index=0&id=242d8047&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242d8047",
  null
  
)

export default component.exports